import React, {Fragment} from "react";

import {priceFormat} from "@pg-mono/string-utils";
import {IComparisonTableCell} from "@pg-rp/comparison-table";

import {useShouldShowPrice} from "../../../../hooks/use_should_show_price";
import {IPropertyDetail} from "../../../../property/types/IPropertyDetail";
import {getCurrency} from "../../../../utils/get_currency";

export const PriceCell: IComparisonTableCell<IPropertyDetail> = (props) => {
    const property = props.item;

    const showPrice = useShouldShowPrice({
        offerPriceVisibility: property.offer.configuration.price_visibility,
        vendorPriceVisibility: property.offer.vendor.configuration.price_visibility,
        vendorId: property.offer.vendor.id
    });

    return showPrice && property.price ? <Fragment>{priceFormat(property.price, {unit: getCurrency({currency: property.offer.currency})})}</Fragment> : null;
};
import React, {Fragment} from "react";

import {priceFormat} from "@pg-mono/string-utils";
import {IComparisonTableCell} from "@pg-rp/comparison-table";

import {useShouldShowPrice} from "../../../../hooks/use_should_show_price";
import {IPropertyDetail} from "../../../../property/types/IPropertyDetail";
import {getCurrency} from "../../../../utils/get_currency";

export const PriceCell: IComparisonTableCell<IPropertyDetail> = (props) => {
    const property = props.item;

    const showPrice = useShouldShowPrice({
        offerPriceVisibility: property.offer.configuration.price_visibility,
        vendorPriceVisibility: property.offer.vendor.configuration.price_visibility,
        vendorId: property.offer.vendor.id
    });

    return showPrice && property.price ? <Fragment>{priceFormat(property.price, {unit: getCurrency({currency: property.offer.currency})})}</Fragment> : null;
};
